/** @jsx jsx */
import { css, jsx } from '@emotion/core'
import { Cell, Heading, HFlow, VFlow } from 'bold-ui'
import CheckPermission from 'components/auth/CheckPermission'
import { Authorization } from 'components/auth/model-authorization'
import { CheckboxField } from 'components/form'
import { CiapCidSelectField } from 'components/form/field/select/CiapCidSelectField/CiapCidSelectField'
import { GrupoCondicaoSelectField } from 'components/form/field/select/GrupoCondicaoSelectField'
import { MetaRoot } from 'util/metaPath'

import { AcompanhamentoCondicaoSaudeFiltrosAvancadosModel } from '../../model/model-acompanhamentoCondicaoSaude'

interface ProblemasCondicoesFilterProps {
  permission: Authorization
  path: MetaRoot<AcompanhamentoCondicaoSaudeFiltrosAvancadosModel>
  canCheckApenasProblemasCondicoesAtivas: boolean
  isInsideModal?: boolean
}

export const AcompanhamentoCondicaoSaudeProblemasCondicoesFilter = (props: ProblemasCondicoesFilterProps) => {
  const { permission, path, canCheckApenasProblemasCondicoesAtivas, isInsideModal = false } = props

  const styles = createStyles()

  return (
    <CheckPermission permission={permission}>
      <Cell size={12}>
        <Heading level={isInsideModal ? 3 : 2}>Problemas e condições</Heading>
      </Cell>
      <Cell size={isInsideModal ? 12 : 6} style={styles.cell}>
        <GrupoCondicaoSelectField
          label='Grupos de condições prioritários'
          name={path.grupoCondicao.absolutePath()}
          multiple
          placeholder='Selecione grupos de condições prioritários'
        />
      </Cell>
      <Cell size={isInsideModal ? 12 : 6} style={styles.cell}>
        <CiapCidSelectField
          label='CIAP2 e CID10'
          name={path.problemasCondicoes.absolutePath()}
          multiple
          placeholder='Selecione outros CIAP2 e CID10'
        />
      </Cell>
      <Cell size={12} style={isInsideModal && styles.cell}>
        <VFlow vSpacing={0.4}>
          <Heading level={5}>Buscar problemas/condições</Heading>
          <HFlow>
            <CheckboxField
              name={path.ativoListaProblema.absolutePath()}
              label='Ativos na lista de problemas e condições'
              disabled={canCheckApenasProblemasCondicoesAtivas}
            />
            <CheckboxField
              name={path.naoIncluidoListaProblema.absolutePath()}
              label='Não incluídos na lista de problemas e condições'
              disabled={canCheckApenasProblemasCondicoesAtivas}
            />
          </HFlow>
        </VFlow>
      </Cell>
    </CheckPermission>
  )
}

const createStyles = () => ({
  cell: css`
    margin-top: 0.5rem;
  `,
  container: css`
    margin-right: 5rem;
  `,
  wrapper: css`
    margin-top: 0.5rem;
  `,
})
